export default {"src":"/_next/static/media/bbq_grill.061a9615.svg","height":100,"width":100};